import type { ChangeEvent } from 'react';
import { Calendar, RefreshCw, Briefcase, Megaphone } from 'lucide-react';
import './DatePicker.css';

export type DashboardMode = 'loans' | 'marketing';

interface DateRangePickerProps {
  startDate: string;
  endDate: string;
  setStartDate: (value: string) => void;
  setEndDate: (value: string) => void;
  onRefresh: () => void;
  loading: boolean;
  mode: DashboardMode;
  onModeChange: (mode: DashboardMode) => void;
}

export default function DateRangePicker({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  onRefresh,
  loading,
  mode,
  onModeChange,
}: DateRangePickerProps) {
  return (
    <div className="date-picker-bar">
      <div className="date-inputs">
        <div className="date-field">
          <Calendar size={16} className="date-icon" />
          <label>From</label>
          <input
            type="date"
            value={startDate}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setStartDate(e.target.value)}
          />
        </div>
        <div className="date-field">
          <Calendar size={16} className="date-icon" />
          <label>To</label>
          <input
            type="date"
            value={endDate}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setEndDate(e.target.value)}
          />
        </div>
      </div>
      <div className="date-picker-actions">
        <div className="mode-toggle" role="tablist" aria-label="Dashboard mode">
          <button
            type="button"
            role="tab"
            aria-selected={mode === 'marketing'}
            className={`mode-toggle-btn ${mode === 'marketing' ? 'active' : ''}`}
            onClick={() => onModeChange('marketing')}
          >
            <Megaphone size={15} />
            Marketing
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={mode === 'loans'}
            className={`mode-toggle-btn ${mode === 'loans' ? 'active' : ''}`}
            onClick={() => onModeChange('loans')}
          >
            <Briefcase size={15} />
            Loans
          </button>
        </div>
        <button className="refresh-btn" onClick={onRefresh} disabled={loading}>
          <RefreshCw size={16} className={loading ? 'spin' : ''} />
          {loading ? 'Loading...' : 'Refresh'}
        </button>
      </div>
    </div>
  );
}
